import { Permission } from '@Constants/Permission.g';
import { useHasPermission, useUsesExternalErp } from '@Contexts/appContext';
import { Button, type ToolbarOptions } from '@synqo/frontend-component-library';
import { useMemo, useState } from 'react';

/**
 * What a list of master data needs to offer the import from the external ERP: the toolbar button,
 * the props of the import flow, and a key which remounts the table once an import has run.
 */
// @ai-generated 2026-10-27T09:00:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function useExternalErpImport(buttonLabel: string) {
    const hasPermission = useHasPermission();
    const usesExternalErp = useUsesExternalErp();
    const [isOpen, setIsOpen] = useState(false);
    const [importCount, setImportCount] = useState(0);
    const canImport = usesExternalErp && hasPermission(Permission.StammdatenExternalErpImportFromErp);

    const toolbarElements = useMemo(
        () =>
            canImport
                ? (standard: ToolbarOptions[]) => [
                      ...standard,
                      <Button key="import-from-erp" onClick={() => setIsOpen(true)} variant="secondary">
                          {buttonLabel}
                      </Button>,
                  ]
                : undefined,
        [canImport, buttonLabel],
    );

    const flowProps = useMemo(
        () => ({
            isOpen,
            onClose: () => setIsOpen(false),
            onImported: () => setImportCount((count) => count + 1),
        }),
        [isOpen],
    );

    return { toolbarElements, flowProps, tableKey: importCount };
}
